export default "__VITE_ASSET__1GDPjqdY__"